import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const GARutinMeny: IRutinInfo[] = [
  rutinInfos.rtnWebGrav,
  rutinInfos.rtnGravsatta,
  rutinInfos.rtnKontakter,
  rutinInfos.rtnSkotselExport,
  rutinInfos.rtnGravHandelseLogg,
  rutinInfos.rtnGravMyCartaUrval,
  rutinInfos.rtnGravKartaTeman,
  rutinInfos.rtnSkotselFakt,
  rutinInfos.rtnAvtalFakt,
  rutinInfos.rtnBestallningsOrder,
  rutinInfos.rtnArbetsunderlagSkapa,
  rutinInfos.rtnArbetsunderlag,
  rutinInfos.rtnFasttidsavtalUppr,
  rutinInfos.rtnAvrakningsavtAvr,
  rutinInfos.rtnAvrakningsavtKalk,
  rutinInfos.rtnUtgaendeSkotsel,
  rutinInfos.rtnWebOrder,
  rutinInfos.rtnFaktura,
  rutinInfos.rtnArtiklar,
  rutinInfos.rtnSkotselKategorier,
  rutinInfos.rtnSkotselBestallningar,
  rutinInfos.rtnKund,
  rutinInfos.rtnAdresser_HarUtgatt,
  rutinInfos.rtnPostnr,
  rutinInfos.rtnOrderOmg,
  rutinInfos.rtnPubliceraGravsatta,
  rutinInfos.rtnInformationskiosk,
  rutinInfos.rtnOrgPersLok,
];

export default GARutinMeny;
